type JobWithStripeSetUp = {
  stripeActiveStatus?: unknown;
  hygienist?: { stripeCreatedTimestamp?: unknown } | null;
} | null | undefined;

/**
 * T2-7370: one rule on every invoice screen for "this temp has set up Stripe
 * Express", so the post-invoice "Set up Express Payment" prompt only asks temps
 * who have not: TempStars recorded the account as created
 * (Hygienist.stripeCreatedTimestamp), the T2-4869 rule. The API sends it as
 * stripeActiveStatus on the completed-shift page and on the talent's own job
 * details; some screens also carry the timestamp on job.hygienist.
 */
export function hasStripeExpressSetUp(job: JobWithStripeSetUp): boolean {
  if (!job) return false;
  return job.stripeActiveStatus === true || job.hygienist?.stripeCreatedTimestamp != null;
}
